<template>
  <easy-marketing-container
    class="container"
    swipe="horizontal"
    @pageChange="handlePageChange"
    :preloadList="preloadList"
    :music="require('./music.mp3')"
    :musicAutoPlay="true"
    :musicEnabledIcon="require('./img/enabled.png')"
    :musicDisabledIcon="require('./img/disabled.png')"
    @pageControl="
      o => {
        pageController = o
      }
    "
    @musicControl="
      o => {
        musicController = o
      }
    "
  >
    <template #others>
      <transition name="bottom-sticker">
        <div class="bottom-sticker" v-show="pageState.current !== 3">
          <img class="receive-image" src="./img/figure.png" alt="" />
          <div class="receive-text">
            <p class="line1">限时领取</p>
            <p class="line2"><strong>398元</strong>名师直播课</p>
          </div>
          <div class="receive-button" @click="doReceive" @touchend="doReceive">
            立即领取
          </div>
        </div>
      </transition>
    </template>

    <easy-marketing-page key="0" :image="assets.bg1">
      <img class="swipe-tip" src="./img/swipe-tip.gif" alt="" />
    </easy-marketing-page>
    <easy-marketing-page key="1" :image="assets.bg2">
      <video
        ref="video"
        :class="['video', isIPhoneX ? 'offset' : '']"
        @play="handleVideoPlay"
        controls
        src="https://img.vipkidstatic.com/ec-edu/math/customer/referral/%E6%95%B0%E5%AD%A6%E6%80%9D%E7%BB%B4-%E8%AF%BE%E4%B8%AD%E4%BA%AE%E7%82%B9%E9%9B%86%E9%94%A6%E8%A7%86%E9%A2%91.mp4"
      ></video>
    </easy-marketing-page>
    <easy-marketing-page
      key="2"
      :image="assets.bg4"
      @click.native="handleLearnMore"
    ></easy-marketing-page>
    <easy-marketing-page key="3" :image="assets.bg3">
      <page-receive-course></page-receive-course>
    </easy-marketing-page>
  </easy-marketing-container>
</template>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;

  /deep/ .easy-marketing-page {
    background-repeat: no-repeat;
  }

  /deep/ .default-music-player {
    left: unset;
    right: 0px;
    padding: 24px;

    img {
      width: 64px;
      height: 64px;
    }
  }

  /deep/ .easy-marketing-page {
    background-size: 100% auto !important;
    background-position-y: top !important;
  }

  .swipe-tip {
    position: absolute;
    width: 100%;
    left: 0px;
    bottom: 0px;
  }
}

.video {
  margin: 0px auto;
  margin-top: 135px;
  width: 600px;
  height: 340px;
}

.video.offset {
  margin-top: 165px;
}

.bottom-sticker {
  position: fixed;
  width: 100%;
  height: 110px;
  bottom: 0px;
  left: 0px;

  color: #fff;
  background: #333;

  .receive-image {
    position: fixed;
    left: 32px;
    bottom: 0px;
    width: 200px;
  }

  .receive-text {
    margin-top: 28px;
    margin-left: 240px;
  }

  .line1 {
    font-size: 20px;
  }
  .line2 {
    margin-top: 5px;
    font-size: 35px;
    strong {
      color: #f85415;
    }
  }

  .receive-button {
    font-size: 32px;
    text-align: center;
    position: fixed;
    background: #f85415;
    right: 0px;
    bottom: 0px;
    width: 180px;
    height: 110px;
    line-height: 110px;
  }
}

.bottom-sticker-enter-active,
.bottom-sticker-leave-active {
  transition: all 0.55s cubic-bezier(0.23, 1, 0.32, 1);
}

.bottom-sticker-enter,
.bottom-sticker-leave-to {
  transform: translate(0px, 100%);
  opacity: 0;
}
</style>

<script>
import sasdk from './sasdkinit'

import {
  EasyMarketingContainer,
  EasyMarketingPage
} from '@mathfe/easy-marketing-h5'
import '@mathfe/easy-marketing-h5/dist/EasyMarketingH5.css'

import PageReceiveCourse from './page-receive-course/index.vue'

import bg1 from './img/1.png'
import bg2 from './img/2.png'
import bg3 from './img/3.png'
import bg4 from './img/4.png'
import bg1x from './img/1x.png'
import bg2x from './img/2x.png'
import bg3x from './img/3x.png'
import bg4x from './img/4x.png'

var appId, channelKeyword, channelId, activityCode

const isIPhoneX = () => {
  if (typeof window !== 'undefined' && window) {
    return (
      /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
    )
  }
  return false
}
console.log(isIPhoneX())

export default {
  components: {
    EasyMarketingContainer,
    EasyMarketingPage,

    PageReceiveCourse
  },
  created () {
    appId = this.$route.query.appId || ''
    channelKeyword = this.$route.query.channelKeyword || ''
    channelId = this.$route.query.channelId || ''
    activityCode = this.$route.query.activityCode || ''
    console.log({ appId, channelKeyword, channelId, activityCode })
    sasdk.registerPage({
      channel_id: channelId
    })
  },
  data () {
    let assets = {
      bg1: isIPhoneX() ? bg1x : bg1,
      bg2: isIPhoneX() ? bg2x : bg2,
      bg3: isIPhoneX() ? bg3x : bg3,
      bg4: isIPhoneX() ? bg4x : bg4
    }
    return {
      isIPhoneX: isIPhoneX(),
      assets,
      preloadList: Object.keys(assets).map(key => assets[key]),
      pageState: {
        current: 0,
        min: 0,
        max: 0
      },
      pausedByVideo: false,
      pageController: {},
      musicController: {}
    }
  },
  methods: {
    doReceive () {
      this.pageController.jump(3)
    },
    handlePageChange (evt) {
      if (this.$refs['video'] && !this.$refs['video'].paused) {
        this.musicController.play()
        this.$refs['video'].pause()
      }
      if (this.pausedByVideo) {
        this.pausedByVideo = false
        this.musicController.play()
      }
      this.$set(this, 'pageState', evt)
    },
    handleVideoPlay () {
      this.musicController.pause()
      this.pausedByVideo = true
      sasdk.watchVideo()
    },
    handleLearnMore () {
      sasdk.joinRightNow()
      window.open(
        'https://mp.weixin.qq.com/s/Q8kJ59FrEIbFKu5j8ReenQ',
        '__blank'
      )
    }
  }
}
</script>
